import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'
import { Typography } from '@mui/material'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: start;
  margin-top: 1.5rem;
  gap: .5rem;
`

export const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 1.5rem;
`

export const CustomButton = styled(ButtonMui)`
  min-width: 12.5rem !important;
  width: 12.5rem;    
  height: 3rem !important;
  margin: 0 !important;
`

export const CustomActionButton = styled(ButtonMui)`
  width: 6.5rem;    
  height: 2.5rem !important;
  margin: 0 !important;
`

export const ContainerSelectedPrinter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
`

export const CustomTypography = styled(Typography)<{hasSavedPrinter: boolean}>`
  background-color: ${({ hasSavedPrinter }) => (hasSavedPrinter ? 'lightgreen' : 'lightcoral')};
  border-radius: 0.5rem;
  width: fit-content;
  padding: 0.5rem;
`
